import { Component, Input, OnInit } from '@angular/core';
import { Garage, PublicBundle } from '@common/core/models';
import { DialogsService } from '@web/core/services';
import { ActivateInvestmentDialogComponent } from '../activate-investment-dialog/activate-investment-dialog.component';

@Component({
  selector: 'cci-vehicle-buy-button',
  templateUrl: './vehicle-buy-button.component.html',
  styleUrls: ['./vehicle-buy-button.component.scss'],
})
export class VehicleBuyButtonComponent implements OnInit {
  @Input() publicBundle: PublicBundle;
  @Input() vehicle: Garage;
  constructor(private dialogsService: DialogsService) {}

  ngOnInit(): void {}

  onClick() {
    this.dialogsService.dialog.open(ActivateInvestmentDialogComponent, {
      // width: '90%',
      // minWidth: '600px',
      maxWidth: '480px',
      // height: '90%',
      // maxHeight: '80%',
      data: { publicBundle: this.publicBundle, vehicle: this.vehicle },
    });
  }
}
